<template>
  <div>
    <digitization-project-storage-summary-text
      :project="project"
      class="mb-4"
    />
    <storage-product-selection
      :add-to-cart="addToCart"
      :is-adding-to-cart="isAddingToCart"
      :one-time-payment-products="oneTimePaymentProducts"
      :monthly-payment-products="monthlyPaymentProducts"
      :upsell-tracking="upsellTracking"
      additional-text="Price includes an additional 90 days of streaming video for your project's digitized videos."
    />
    <digitization-extend-time-card
      :project="project"
      :show-expanded="extensionExpanded"
      :upsell-tracking="upsellTracking"
      class="mt-3"
    />
  </div>
</template>

<script setup>
  const props = defineProps({
    oneTimePaymentProducts: Array,
    monthlyPaymentProducts: Array,
    project: {
      type: Object,
      required: true
    },
    extensionExpanded: Boolean,
    upsellTracking: Object
  });

  const isAddingToCart = ref(false);
  async function addToCart(product) {
    if (isAddingToCart.value) return;

    isAddingToCart.value = true;
    try {

      await useDigitizationApiService().addDigiProjectStorageToCart({
        product,
        projectId: props.project.id
      });

      window.location = EXTERNAL_URLS.cart;
    } catch {
      useErrorToast().add('Unable to add to cart at this time. Please try again later.');
    } finally {
      isAddingToCart.value = false;
    }
  }
</script>
